/**
 * Home router
 * @param $stateProvider
 */
function commonRouter($stateProvider) {
    'ngInject';

    $stateProvider.state('portail-home', {
        url : '/portail/home/',
        data: {
            title: function ($stateParams, $translate) {
                var customer = angular.fromJson(sessionStorage.getItem('auth-infos'));

                if (customer.data.data.customers === undefined) {
                    return '';
                }

                if (customer && customer.data && customer.data.data.customers[0]) {
                    var customerInfos = customer.data.data.customers[0];

                    return $translate.instant('WC.WELCOME_MSG', {
                        customerGender:
                            customerInfos.sexe_client === 1
                                ? $translate.instant('WC.MR')
                                : $translate.instant('WC.MRS'),
                        customerName: customerInfos.nom_client,
                        nim         : customer.data.data.code_nim_magasin
                    });
                }

                return '';
            }
        },
        template    : require('./partials/portail.html'),
        controller  : 'PortailCtrl',
        controllerAs: 'portailCtrl',
        resolve     : {
            cards: function (portailService) {
                return portailService.getCards();
            }
        }
    });
}

angular.module('app.portail.common', []).config(commonRouter);
require('./controllers/portailCtrl');
require('./services/portailService');
require('./services/bandeauService');
